import EBarSearchPage from './EBarSearchPage';

export default EBarSearchPage;
